import { useState, useEffect } from "react"
import { API } from "aws-amplify"

const usePartyStatus = (organizationId, enabled) => {
  const [status, setStatus] = useState(null)
  const [linkUrl, setLinkUrl] = useState(null)
  const [loading, setLoading] = useState(true)

  const fetchStatus = async () => {
    setLoading(true)
    try {
      const response = await API.get(
        "CORE",
        `/invopop/verifactu/party_status/${organizationId}`,
      )
      setStatus(response?.status || null)
      setLinkUrl(response?.link_url || null)
      return response
    } catch (error) {
      if (error?.response?.status === 404) {
        setStatus(null)
        setLinkUrl(null)
        return null
      }
      console.error(
        "party-status-fetch-failed:",
        error?.response?.data?.code || error?.message || "unknown",
      )
      return null
    } finally {
      setLoading(false)
    }
  }

  useEffect(() => {
    if (enabled && organizationId) {
      fetchStatus()
    }
  }, [enabled, organizationId])

  return { status, linkUrl, loading, refetch: fetchStatus }
}

export default usePartyStatus
